const VARIABLE_NAME = '--vh';

/**
 * Хак для вычисления vh (но только при рендере она учтет размер окна)
 */
export const calculationVHDuringRendering = (): void => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty(VARIABLE_NAME, `${vh}px`);
};
